import { render, staticRenderFns } from "./PageErreur.vue?vue&type=template&id=90faadfe"
import script from "./PageErreur.vue?vue&type=script&lang=js"
export * from "./PageErreur.vue?vue&type=script&lang=js"
import style0 from "./PageErreur.vue?vue&type=style&index=0&id=90faadfe&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports